var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
export default class IpInfo {
  constructor(token) {
    this.ipInfotoken = token;
  }
  getLocationInfo() {
    return __async(this, null, function* () {
      const response = yield fetch(ANALYTICS_CONFIG_API_URL + "/v2/ip");
      const data = yield response.json();
      if (data.data.attributes) {
        const ip = data.data.attributes;
        return {
          ip: ip.ip
        };
      }
    });
  }
}
